import React from 'react'
import { QuestionUtils } from '../../../utils/siteUtils'

import Question from './Question'

export default ({ getQuestionResponse, saveQuestionResponse, saveQuestionResponseComment, getQuestionResponseComment, question }) => {
  const { questionLabel, questionId, questionChoices } = QuestionUtils.getQuestionLabelAndChoices(question)
  const selectedIndex = getQuestionResponse(questionId).v

  return (
    <Question
      question={question}
      title={questionLabel}
      subtitle={question.labelExtended}
      comment={question.acceptsComment}
      selectedIndex={selectedIndex}
      questionChoices={questionChoices}
      questionId={questionId}
      fullWidth={true}
      {...{ saveQuestionResponse, saveQuestionResponseComment, getQuestionResponseComment }}
    />
  )
}
